module.exports = __webpack_public_path__ + "static/media/UnlockSymbol.ee97d320.svg";